import { render } from "./FishSkeleton.vue?vue&type=template&id=f78ca910&scoped=true"
import script from "./FishSkeleton.vue?vue&type=script&lang=js"
export * from "./FishSkeleton.vue?vue&type=script&lang=js"

import "./FishSkeleton.vue?vue&type=style&index=0&id=f78ca910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f78ca910"]])

export default __exports__